export const anomalyBundle = {
  title: {
    ko: "AI 상태 진단",
    en: "AI Status Diagnosis",
    es: "Diagnostico de estado con IA"
  },
  description: {
    ko: "누수 및 검침 이상 여부를 자동 분석합니다.",
    en: "Automatically analyzes leak risks and meter reading anomalies.",
    es: "Analiza automaticamente riesgos de fuga y anomalias de lectura del medidor."
  },
  normal: {
    status: { ko: "정상", en: "Normal", es: "Normal" },
    title: {
      ko: "모든 항목이 정상입니다.",
      en: "All Items Are Normal",
      es: "Todos los elementos son normales"
    },
    desc: {
      ko: "선택한 기간 기준 이상 상태가 감지되지 않았습니다.",
      en: "No anomalies were detected during the selected period.",
      es: "No se detectaron anomalias durante el periodo seleccionado."
    }
  },
  leak: {
    title: {
      ko: "옥내누수 의심 세대",
      en: "Suspected Indoor Water Leak Households",
      es: "Hogares con sospecha de fuga interior"
    },
    desc: {
      ko: "누수 가능성이 있는 사용 패턴이 감지되었습니다.",
      en: "Consumption patterns indicating potential water leaks were detected.",
      es: "Se detectaron patrones de consumo que indican posibles fugas de agua."
    }
  },
  negative: {
    title: {
      ko: "계량기 이상 세대",
      en: "Meter Inspection Required",
      es: "Inspeccion de medidor requerida"
    },
    desc: {
      ko: "검침 데이터의 이상이 감지된 세대입니다.",
      en: "Households with abnormal meter reading data detected.",
      es: "Se detectaron hogares con datos anormales de lectura del medidor."
    },
    none: {
      ko: "검침 데이터의 이상이 감지되지 않았습니다.",
      en: "No abnormal meter reading data was detected.",
      es: "No se detectaron datos anormales de lectura del medidor."
    },
    count: { ko: "{count}건", en: "{count} cases", es: "{count} casos" }
  },
  vacant: {
    title: { ko: "빈집 세대", en: "Vacant Households", es: "Hogares vacios" },
    desc: {
      ko: "사용량이 장기간 발생하지 않은 세대입니다.",
      en: "Households with no recorded consumption for an extended period.",
      es: "Hogares sin consumo registrado durante un periodo prolongado."
    },
    count: { ko: "{count}세대", en: "{count} households", es: "{count} hogares" }
  }
}
